import _ from "lodash";
import {reactLocalStorage} from "reactjs-localstorage";
import {langs} from "../config/localization";
import {
    stripHtml,
    formatVideoDuration, timeAgo, urlify
} from "../utils";
import {DEFAULT_USER_IMAGE} from "../config/config";
import {
    PROPS_DATA
} from '../actions/Types';
import {getUserProfileDetails} from "./UserAction";


/**
 * Check if user is logged in or not
 * @returns {boolean}
 */
export function isUserLoggedIn() {
    //if(!_.isEmpty(reactLocalStorage.getObject("user_auth_details"))) {

    if(!_.isEmpty(getAuthUserDetails())) {
        return true;
    } else {
        return false;
    }
}

/**
 * Get logged in user's auth token
 * @returns {string}
 */
export function getAuthToken() {
    let authToken = '';

    if(isUserLoggedIn()) {
        const user = getAuthUserDetails();
        authToken = user.loginToken;
    }

    return authToken;
}

/**
 * Get logged in user's id
 * @returns {string}
 */
export function getUserId() {
    let authId = '';

    if(isUserLoggedIn()) {
        const user = getAuthUserDetails();
        authId = user.userId;
    }

    return authId;
}

/**
 * Get logged in user's auth token
 * @returns {string}
 */
export function getAuthUserProfilePic() {
    let profilePic = DEFAULT_USER_IMAGE;

    if(isUserLoggedIn()) {
        /*const avatar = reactLocalStorage.getObject("user_auth_details").avatar;
        const customAvatar = reactLocalStorage.getObject("user_auth_details").customAvatar;*/
        const authUser = getAuthUserDetails();
        profilePic = authUser.user.profilePic;
    }
    return profilePic;
}



/**
 * Get user's profile pic
 * @param userImage
 * @returns {*}
 */
export function getUserProfilePic(userImage) {
    return (userImage != '' && userImage != null) ? userImage : DEFAULT_USER_IMAGE;
}



/**
 * Get auth user details
 * @returns {*}
 */
export function getAuthUserDetails() {
    return reactLocalStorage.getObject("user_auth_details");
}

/**
 * Prepare user attributes
 * @param user
 * @returns {{name: string, userImage: string, averageRating: number, followingCount: number, followersCount: number}}
 */
export function userAttributes(user) {

    let attributes = {
        id              : '',
        name       : '',
        email           : ''
    };

    const userData = user;

    attributes.id           = userData.user_id;
    attributes.name         = userData.name;
    attributes.email        = userData.email;
    return attributes;
}

export function profileAttributes(user) {

    let attributes = {
        name       : '',
        email      : '',
        location   : '',
        profilePic : '',
        profile    : ''
    };

    attributes.name         = user.name;
    attributes.email        = user.email;
    attributes.location     = user.location;
    attributes.profilePic   = user.profilePic;
    attributes.profile      = user.profile;

    return attributes;
}



/**
 * Update user details in local storage
 * @param user
 */
export function updateUserDetailsLocalStorage(user) {
    reactLocalStorage.setObject("user_auth_details", user);
}

/**
 * Update user details in local storage
 * @param user
 */
export function updateProfilePicLocalStorage(image) {
    var state = reactLocalStorage.getObject("user_auth_details")
    var newState =  {
        ...state,
        user: {
            ...state.user,
            profilePic: image.profilePic
        }
    }
    reactLocalStorage.setObject("user_auth_details", newState);
    reactLocalStorage.setObject("user_profile_picture", image);
}

export function updateUserNameLocalStorage(name) {
    console.log('name=', name);
    const userDetails = getAuthUserDetails();
    userDetails.user.name = name;
    updateUserDetailsLocalStorage(userDetails);
    //reactLocalStorage.setObject("user_auth_details", newState);
}

/**
 * Update user details in local storage
 * @param user
 */
export function updateUserTagClickLocalStorage(tag) {
    reactLocalStorage.setObject("tag_click", tag);
}

/**
 * Update user attributes in local storage
 * @param key
 * @param value
 */
export function updateUserAttributesLocalStorage(key, value) {
    const user  = getAuthUserDetails();
    user[key]   = value;
    updateUserDetailsLocalStorage(user);
}

/**
 * Get auth user's language
 */
export function getAuthUserLanguage() {
    let language = 'en';

    if(isUserLoggedIn()) {
        language = getAuthUserDetails().language;
    }

    return language;
}



/**
 * Check whether paid courses exist or not
 * @param profileData
 * @returns {boolean}
 */
export function paidCoursesExist(profileData) {
    let paidCourses = [];

    if(profileData != undefined) {
        //Get paid courses from my profile
        paidCourses = profileData.paidCourses;
    }

    return paidCourses.length > 0 ? true : false;
}

/**
 * Get auth user id
 */
export function getAuthUserId() {
    const userData  = getAuthUserDetails();
    const {id}      = userAttributes(userData);
    return id;
}

/**
 * Get user fullname
 */
export function getAuthUserFullName() {
    const userData = getAuthUserDetails();
    return (userData && userData.user && userData.user.name && userData.user.name.trim()+`'s`) || '';
}

/**
 * Update user details in local storage
 * @param user
 */
export function setVideoDetailLocalStorage(video_details) {
    reactLocalStorage.setObject("video_details", video_details);
    setTimeout(function () {
        reactLocalStorage.setObject("video_details", {});
    }, 180000);
}

/**
 * Update user details in local storage
 * @param user
 */
export function getVideoDetailLocalStorage() {
    return reactLocalStorage.getObject("video_details");
}

/**
 * Update user details in local storage
 * @param user
 */
export function getTagClickDetailLocalStorage() {
    return reactLocalStorage.getObject("tag_click");
}


/**
 * Get user profile pic details in local storage
 * @param user
 */
export function getUserProfilePictureLocalStorage() {
    return reactLocalStorage.getObject("user_profile_picture");
}

/**
 * Get font classes
 * @param order
 */
/*export function getFontClass(order) {
    if(order >= 1 && order < 5) {
        return 'font15';
    } else if(order >= 5 && order < 9) {
        return 'font20';
    } else if(order >= 9 && order < 13) {
        return 'font24';
    } else if(order >= 13 && order < 17) {
        return 'font30';
    } else if(order >= 17 && order < 21) {
        return 'font36';
    } else if(order >= 21 && order < 25) {
        return 'font44';
    } else if(order >= 25 && order < 29) {
        return 'font56';
    } else {
        return 'font72';
    }
}*/

/**
 * Define font class based on tag order
 * @param order
 * @returns {string}
 */
export function getFontClass(order) {
    if(order >= 0 && order < 5) {
        return 'font72';
    } else if(order >= 5 && order < 10) {
        return 'font56';
    } else if(order >= 10 && order < 15) {
        return 'font44';
    } else if(order >= 15 && order < 20) {
        return 'font36';
    } else if(order >= 20 && order < 25) {
        return 'font30';
    } else if(order >= 25 && order < 30) {
        return 'font24';
    } else if(order >= 30 && order < 35) {
        return 'font20';
    }
}


// WEBPACK FOOTER //
// ./actions/Common.js